import { apiSlice } from './apiSlice';

const ACHIEVEMENT_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1/achievements`;

export const achievementApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Check which achievements the user has newly unlocked
    checkAchievement: builder.query({
      query: () => ({
        url: `${ACHIEVEMENT_URL}/check-achivement`,
        method: 'GET',
        credentials: 'include',
      }),
    }),

    // Create (save) an unlocked achievement
    createAchievement: builder.mutation({
      query: (data) => ({
        url: `${ACHIEVEMENT_URL}/create-achivement`,
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
    }),

    // Get all achievements of the user
    getAllAchievements: builder.query({
      query: () => ({
        url: `${ACHIEVEMENT_URL}/get-all-achivement`,
        method: 'GET',
        credentials: 'include',
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useCheckAchievementQuery,
  useCreateAchievementMutation,
  useGetAllAchievementsQuery,
} = achievementApiSlice;